/*! For license information please see Dart_H5_main.js.LICENSE.txt */ ! function() {
	var t = {
        "./src/assets/js/common.js": function(t, e, n) {
            "use strict";
            var r = n("jquery");

            function o(t, e) {
                var n = Object.keys(t);
                if(Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter((function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable
                    }))), n.push.apply(n, r)
                }
                return n
            }

            function i(t) {
                for(var e = 1; e < arguments.length; e++) {
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? o(Object(n), !0).forEach((function(e) {
                        s(t, e, n[e])
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach((function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e))
                    }))
                }
                return t
            }

            function s(t, e, n) {
                return(e = function(t) {
                    var e = function(t, e) {
                        if("object" != a(t) || !t) return t;
                        var n = t[Symbol.toPrimitive];
                        if(void 0 !== n) {
                            var r = n.call(t, e || "default");
                            if("object" != a(r)) return r;
                            throw new TypeError("@@toPrimitive must return a primitive value.")
                        }
                        return("string" === e ? String : Number)(t)
                    }(t, "string");
                    return "symbol" == a(e) ? e : e + ""
                }(e)) in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t
            }

            function a(t) {
                return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
                }, a(t)
            }
            window.debounce = function(t, e, n) {
                var r;
                return function() {
                    var o = this,
                        i = arguments,
                        s = n && !r;
                    clearTimeout(r), r = setTimeout((function() {
                        r = null, n || t.apply(o, i)
                    }), e), s && t.apply(o, i)
                }
            }, window.clamp = function(t, e, n) {
                return n < t ? t : e < n ? e : n
            }, window.loadCSS = function(t, e) {
                var n = document.createElement("link");
                n.rel = "stylesheet", n.type = "text/css", n.href = t, n.onload = function() {
                    e && e()
                }, document.head.appendChild(n)
            }, window.loadScript = function(t, e) {
                var n = document.createElement("script");
                n.type = "text/javascript", n.src = t, n.onload = function() {
                    e && e()
                }, document.head.appendChild(n)
            };
            ! function() {
                var t = function(t) {
                    return !(t.startsWith(".swiper") || ".purchase-sales-channel-btn" === t)
                };
                ! function(e) {
                    e.extend({
                        CN: function(e) {
                            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t,
                                r = function(t) {
                                    return "" === t ? null : (e = t, !n && e.includes("#") ? e : e.startsWith(".") || e.includes(".") ? e.split(".").join(".".concat("Dart_H5_")) : e);
                                    var e
                                };
                            return e.split(",").map((function(t) {
                                return t.trim().split(" ").map((function(t) {
                                    return t.replace(/(\.[^.]*)/g, (function(t) {
                                        return("function" == typeof n ? n(t) : n) ? r(t) : t
                                    }))
                                })).join(" ")
                            })).join(", ")
                        }
                    })
                }(r);
                var e = 0;
                window.addEventListener("scroll", (function(t) {
                    0 != window.scrollY && (e = window.scrollY)
                })), r("#product_subscription_b").on("click", (function() {
                    r("#subscribe-modal").css({
                        display: "block"
                    })
                })), window.isVisible = function t(e) {
                    if(!e) return !1;
                    if(e == document.documentElement) return !0;
                    var n = window.getComputedStyle(e);
                    if("none" === n.display || "hidden" === n.visibility) return !1;
                    var r = e.getBoundingClientRect();
                    return 0 !== r.width && 0 !== r.height && (!e.parentElement || t(e.parentElement))
                }, window.isPopupShown = !1, window.afterPopupShown = function() {
                    r(document.documentElement).css("--scroll-padding", window.innerWidth - document.body.clientWidth + 5 + "px"), r("body").css({
                        top: "-" + e + "px"
                    }).addClass("".concat("Dart_H5_", "has-popup")), r("#sideBtn").hide(), window.isPopupShown = !0
                }, window.afterPopupHidden = function() {
                    var t = -1 * Number(r("body").css("top").replace("px", ""));
                    document.documentElement.style.setProperty("--scroll-padding", "0px"), r("body").removeClass("".concat("Dart_H5_", "has-popup")).css({
                        top: "0px"
                    }), window.scrollTo(0, t), r("#sideBtn").show(), window.isPopupShown = !1
                }, window.trackDirection = function t(e) {
                    "object" !== a(e) && (e = {
                        onUpdate: e
                    });
                    var n = 0,
                        r = !1,
                        o = e.eventCallback ? e : e.animation,
                        i = e.onUpdate,
                        s = e.onToggle;
                    return o ? o.eventCallback("onUpdate", t({
                        onUpdate: i,
                        onToggle: s
                    })) : function() {
                        var t = this.totalTime(),
                            e = t < n;
                        this.direction = e ? -1 : 1, e !== r && (s && s.call(this, this.direction), r = e), n = t, i && i.call(this, this.direction)
                    }
                }, window.markers = !1, r((function() {
                    function t(t) {
                        var e = document.createElement("div");
                        e.style.width = "var(".concat(t, ")"), document.body.appendChild(e);
                        var n = getComputedStyle(e).width;
                        return document.body.removeChild(e), Number(n.replace("px", ""))
                    }
                    r(".ad-bar").length > 0 && r(r.CN(".container")).css({
                        "margin-top": "110px"
                    }), r("#product_subscription_b").on("click", (function() {
                        r("#subscribe-modal").css({
                            display: "block"
                        })
                    })), navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && -1 == navigator.userAgent.indexOf("CriOS") && -1 == navigator.userAgent.indexOf("FxiOS") && r(document.body).addClass("".concat("Dart_H5_", "issafari")), window.$ = r, window.onresize = function() {
                        document.documentElement.style.setProperty("--full-view-height", "".concat(window.innerHeight, "px"));
                        var e = getComputedStyle(document.body);
                        window.bodyFontSize = Number(e.getPropertyValue("--body-font-size")), window.contentWidth1 = t("--content-width-1"), window.contentWidth2 = t("--content-width-2"), window.contentWidth3 = t("--content-width-3"), window.contentPadding1 = t("--content-padding-1"), window.contentPadding2 = t("--content-padding-2"), window.contentPadding3 = t("--content-padding-3"), window.contentNegetivePadding1 = t("--content-negetive-padding-1"), window.contentNegetivePadding2 = t("--content-negetive-padding-2"), window.contentNegetivePadding3 = t("--content-negetive-padding-3"), window.pageTopPadding = Number((e.getPropertyValue("--page-top-padding") || "0").replace("px", "")), window.sectionMinHeight = window.innerHeight, window.sectionMinHeightWithoutTop = window.sectionMinHeight - window.pageTopPadding
                    }, window.onresize();
                    var e = ScrollTrigger.create;
                    ScrollTrigger.create = function(t) {
                        if(t.tags) {
                            var n = t.tags.map((function(t) {
                                return i(i({}, "number" == typeof t ? {
                                    progress: t,
                                    tag: t
                                } : t), {}, {
                                    triggered: !1
                                })
                            }));
                            this._lastProgress = 0;
                            var r = t.onUpdate;
                            t.onUpdate = function(e) {
                                var o = e.progress,
                                    i = o > e._lastProgress ? "forward" : "backward";
                                n.forEach((function(e) {
                                    ("forward" === i && !e.triggered && o >= e.progress || "backward" === i && e.triggered && o <= e.progress) && (t.onTag && t.onTag({
                                        tag: e.tag,
                                        progress: e.progress,
                                        direction: i
                                    }), e.triggered = !e.triggered)
                                })), r && r(e), e._lastProgress = o
                            }
                        }
                        return e(t)
                    }, r("".concat(r.CN(".fade-out"))).each((function() {
                        ScrollTrigger.create({
                            trigger: r(this),
                            start: "top bottom-=" + (isPhone ? "5%" : "15%"),
                            end: "top+=" + (isPhone ? 100 : 150) + " bottom-=" + (isPhone ? "5%" : "15%"),
                            onEnter: function(t) {
                                gsap.fromTo(r(t.trigger), {
                                    y: 40,
                                    opacity: 0
                                }, {
                                    y: 0,
                                    opacity: 1,
                                    ease: "sine.inOut",
                                    immediateRender: !0
                                })
                            },
                            markers: markers,
                            invalidateOnRefresh: !0,
                            scrub: .5
                        })
                    })), r("video[data-src]").each((function() {
                        var t = r(this).get(0),
                            e = t.getAttribute("data-src");
                        ScrollTrigger.create({
                            trigger: r(this),
                            start: "top-=" + (isPhone ? 200 : 350) + " bottom",
                            end: "bottom+=" + (isPhone ? 200 : 350) + " top",
                            onEnter: function(n) {
                                if(isVisible(t)) {
                                    t.src = e, t.onload = function() {
                                        ScrollTrigger.refresh()
                                    };
                                    try {
                                        t.play()
                                    } catch(t) {}
                                }
                            },
                            onEnterBack: function(n) {
                                if(isVisible(t)) {
                                    t.src = e, t.onload = function() {
                                        ScrollTrigger.refresh()
                                    };
                                    try {
                                        t.play()
                                    } catch(t) {}
                                }
                            },
                            once: !0,
                            markers: markers,
                            invalidateOnRefresh: !0,
                            scrub: !1
                        })
                    })), r("img[data-src]").each((function() {
                        var t = r(this).get(0),
                            e = t.getAttribute("data-src"),
                            n = this;
                        ScrollTrigger.create({
                            trigger: r(n),
                            start: "top-=" + (isPhone ? 200 : 350) + " bottom",
                            end: "bottom+=" + (isPhone ? 200 : 350) + " top",
                            onEnter: function(n) {
                                isVisible(t) && (t.src = e), t.onload = function() {
                                    ScrollTrigger.refresh()
                                }
                            },
                            onEnterBack: function(n) {
                                isVisible(t) && (t.src = e), t.onload = function() {
                                    ScrollTrigger.refresh()
                                }
                            },
                            id: r(n).data("test"),
                            once: !0,
                            markers: !!r(n).data("test"),
                            invalidateOnRefresh: !0,
                            scrub: !1
                        })
                    })), setTimeout((function() {
                        r(r.CN(".small-bar")).each((function() {
                            ScrollTrigger.create({
                                trigger: this,
                                start: "bottom bottom-=15%",
                                end: "bottom bottom-=15%",
                                onEnter: function(t) {
                                    r(t.trigger).addClass("".concat("Dart_H5_", "active"))
                                },
                                onLeaveBack: function(t) {
                                    r(t.trigger).removeClass("".concat("Dart_H5_", "active"))
                                },
                                invalidateOnRefresh: !0,
                                scrub: .5
                            })
                        }))
                    }), 500), setTimeout((function() {
                        r(r.CN(".img-holder.offset-view")).each((function() {
                            var t = gsap.timeline();
                            t.add(gsap.fromTo(r(this).find("img"), {
                                scale: 1.1,
                                y: "-4.9%"
                            }, {
                                scale: 1.1,
                                y: "4.9%",
                                ease: "sine.inOut",
                                immediateRender: !0,
                                duration: 1
                            })), ScrollTrigger.create({
                                animation: t,
                                trigger: this,
                                start: "top bottom-=0%",
                                end: "bottom top+=0%",
                                markers: markers,
                                invalidateOnRefresh: !0,
                                scrub: 1
                            })
                        }))
                    }), 100);
                    var n = new Lenis({
                        duration: .5
                    });
                    n.on("scroll", ScrollTrigger.update), gsap.ticker.add((function(t) {
                        n.raf(500 * t)
                    })), gsap.ticker.lagSmoothing(0)
                }))
            }()
        },
        "./src/i18n/index.js": function(t, e, n) {
            "use strict";
            var r = n("jquery");
            n("./src/i18n/font.less"), r((function() {
                window.dispatchEvent(new Event("languagechange"))
            }))
        },
        "./src/sections/index.js": function(t, e, n) {
            "use strict";
            n("./src/sections/section1/index.js"), n("./src/sections/section2/index.js"), n("./src/sections/section5/index.js"), n("./src/sections/section7/index.js"), n("./src/sections/section8/index.js"), n("./src/sections/section9/index.js"), n("./src/sections/section10/index.js"), n("./src/sections/section12/index.js"), n("./src/sections/section13/index.js"), n("./src/sections/section14/index.js"), n("./src/sections/section15/index.js"), n("./src/sections/section16/index.js"), n("./src/sections/section17/index.js"), n("./src/sections/section18/index.js"), n("./src/sections/section19/index.js"), n("./src/sections/section20/index.js"), n("./src/sections/section21/index.js")
        },
        "./src/sections/section10/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section12/index.js": function(t, e, n) {
            "use strict";
            var r = n("jquery");
            r((function() {
                var t = document.getElementById("svg-progress"),
                    e = t.getTotalLength();
                t.style.strokeDasharray = e, t.style.strokeDashoffset = e;
                var n = gsap.timeline();
                n.add([gsap.fromTo("#svg-flash", {
                    fill: "#565656"
                }, {
                    fill: "#FF824C",
                    duration: 1
                })]);
                var o = !1;
                ScrollTrigger.create({
                    animation: n,
                    pin: r.CN(".section-12"),
                    trigger: r.CN(".section-12 .content-container .bottom-part"),
                    start: function() {
                        return "top-=" + window.pageTopPadding + " top"
                    },
                    end: "bottom top",
                    onUpdate: function(t) {
                        var e = t.progress;
                        (o || t.isActive) && (o = !0), o || (e = 0);
                        var n = document.getElementById("svg-progress"),
                            r = n.getTotalLength();
                        n.style.strokeDasharray = r;
                        var i = clamp(0, 1.5 * e, 1);
                        n.style.strokeDashoffset = r - r * i
                    },
                    markers: markers,
                    anticipatePin: 1,
                    scrub: 1
                }), isPhone && r(r.CN(".section-12 .bottom-part")).css({
                    maxHeight: window.sectionMinHeight
                })
            }))
        },
        "./src/sections/section13/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section14/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section15/index.js": function(t, e, n) {
            "use strict";
            var r = n("jquery");
            r((function() {
                ScrollTrigger.create({
                    trigger: r.CN(".section-15 .right-part"),
                    start: "bottom bottom",
                    end: "bottom bottom",
                    markers: markers,
                    onEnter: function() {
                        r(r.CN(".section-15")).addClass("".concat("Dart_H5_", "active"))
                    },
                    onLeaveBack: function() {
                        r(r.CN(".section-15")).removeClass("".concat("Dart_H5_", "active"))
                    }
                })
            }))
        },
        "./src/sections/section16/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section17/index.js": function(t, e, n) {
            "use strict";
            var r = n("jquery");
            r((function() {
                window.addEventListener("languagechange", (function() {
                    "fr" != window.LANGUAGE && "es" != window.LANGUAGE && "it" != window.LANGUAGE || r(r.CN(".section-17 .card:nth-child(1) .card-content .number")).text("99,7")
                }))
            }))
        },
        "./src/sections/section18/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section19/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section1/index.js": function(t, e, n) {
            "use strict";
            var r = n("jquery");
            r((function() {
                if(!window.isPhone) {
                    var t = gsap.timeline();
                    t.add(gsap.fromTo(r.CN(".section-1 .img-holder img"), {
                        scale: 1.4
                    }, {
                        scale: 1,
                        duration: 3,
                        ease: "expo.out"
                    })).add(gsap.fromTo(r.CN(".section-1 .text-holder .title"), {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 2,
                        ease: "expo.out"
                    }), "-=1").add(gsap.fromTo(r.CN(".section-1 .text-holder .sub-title"), {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 2,
                        ease: "expo.out"
                    }), "-=1"), t.play()
                }
            }))
        },
        "./src/sections/section20/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section21/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section2/index.js": function(t, e, n) {
            "use strict";
            var r = n("jquery");
            r((function() {
                n("./src/widgets/FullScreenVideo/index.js");
                var t = window.tt = gsap.fromTo(r.CN(".section-2 .title-area"), 1, {}, {
                    paused: !0,
                    onUpdate: function() {
                        var t = this.progress();
                        r(r.CN(".section-2 .title-area .text.mask")).css({
                            "-webkit-mask-image": "linear-gradient(135deg, black " + (150 * t - 50) + "%,  transparent " + 150 * t + "%)",
                            "mask-image": "linear-gradient(135deg, black " + (150 * t - 50) + "%,  transparent " + 150 * t + "%)"
                        })
                    }
                });
                ScrollTrigger.create({
                    animation: gsap.timeline().add(gsap.fromTo(r.CN(".section-2 .title-area"), 2, {}, {
                        onUpdate: trackDirection({
                            onToggle: function(e) {
                                -1 == e ? t.reverse() : t.play()
                            }
                        })
                    })).set(r.CN(".section-2 .text-area"), {
                        opacity: 0
                    }).set(r.CN(".section-2 .btns"), {
                        opacity: 0
                    }).set(r.CN(".section-2 .playvideo-wrapper"), {
                        opacity: 0
                    }).add(gsap.fromTo(r.CN(".section-2 .text-area"), 1, {
                        opacity: 0
                    }, {
                        opacity: 1
                    })).add(gsap.fromTo(r.CN(".section-2 .btns"), 1, {
                        opacity: 0
                    }, {
                        opacity: 1
                    })).add(gsap.fromTo(r.CN(".section-2 .playvideo-wrapper"), 1, {
                        opacity: 0
                    }, {
                        opacity: 1
                    })),
                    trigger: r.CN(".section-2 .text-area-wrapper"),
                    start: (isPhone, "top bottom-=20%"),
                    endTrigger: r.CN(".section-2"),
                    end: isPhone ? "top bottom-=10%" : "bottom bottom-=10%",
                    once: !0,
                    scrub: !0,
                    markers: markers,
                    invalidateOnRefresh: !0,
                    id: "s2"
                })
            }))
        },
        "./src/sections/section5/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section7/index.js": function(t, e, n) {
            "use strict";
            n("./node_modules/regenerator-runtime/runtime.js");
            var r = n("jquery");
            r((function() {
                var t = gsap.timeline({
                    paused: !0
                });
                t.add([gsap.fromTo(r.CN(".section-7 .top-part .bg"), {
                    opacity: "0"
                }, {
                    opacity: "1",
                    duration: .6,
                    ease: "quart.inOut"
                }), gsap.fromTo(r.CN(".section-7 .top-part .pic1"), {
                    y: "5%"
                }, {
                    y: "0.00001%",
                    duration: .6,
                    ease: "quart.inOut"
                }), gsap.fromTo(r.CN(".section-7 .top-part .pic-shadow"), {
                    opacity: 1
                }, {
                    opacity: .5,
                    duration: .6,
                    ease: "quart.inOut"
                })]), t.add(gsap.fromTo(r.CN(".section-7 .top-part .title"), {
                    y: 0
                }, {
                    y: function() {
                        return -1.2 * r(r.CN(".section-7 .top-part .title")).outerHeight()
                    },
                    onUpdate: function() {
                        var t = this;
                        requestAnimationFrame((function() {
                            if(!(t.duration() <= 0)) {
                                var e = t.progress();
                                r(r.CN(".section-7 .top-part .title")).css({
                                    background: "linear-gradient(180deg, #000 ".concat(200 * e - 100, "%, rgba(0, 0, 0, 0) ").concat(200 * e, "%) text"),
                                    backgroundClip: "text",
                                    "-webkit-background-clip": "text"
                                })
                            }
                        }))
                    },
                    duration: .6,
                    ease: "quad.out",
                    immediateRender: !0
                }));
                var e = gsap.timeline({
                    paused: !0
                });
                e.add([gsap.to(r.CN(".section-7 .top-part .bg"), {
                    opacity: "0",
                    duration: .6,
                    ease: "quart.inOut"
                }), gsap.fromTo(r.CN(".section-7 .top-part .title"), {
                    y: function() {
                        return -.7 * r(r.CN(".section-7 .top-part .title")).outerHeight()
                    },
                    opacity: 1
                }, {
                    y: function() {
                        return -1 * r(r.CN(".section-7 .top-part .title")).outerHeight()
                    },
                    opacity: 0,
                    duration: .3,
                    ease: "quart.inOut"
                }), gsap.to(r.CN(".section-7 .top-part .pic2"), {
                    opacity: 1,
                    duration: 1.2,
                    ease: "quad.out"
                })]), ScrollTrigger.create({
                    tags: [{
                        progress: 0,
                        tag: "first"
                    }, {
                        progress: .6,
                        tag: "second"
                    }, {
                        progress: .99,
                        tag: "third"
                    }],
                    onTag: function(n) {
                        var o = n.tag,
                            i = (n.progress, n.direction);
                        "first" == o && ("forward" == i ? t.play() : t.reverse()), "second" == o && ("forward" == i ? e.play() : e.reverse()), "third" == o && ("forward" == i ? gsap.to(r.CN(".section-7 .bottom-part"), {
                            opacity: "1",
                            duration: .6,
                            ease: "quart.inOut"
                        }) : gsap.to(r.CN(".section-7 .bottom-part"), {
                            opacity: "0",
                            duration: .6,
                            ease: "quart.inOut"
                        }))
                    },
                    pin: r.CN(".section-7"),
                    trigger: r.CN(".section-7 .top-part"),
                    start: "top top",
                    end: "bottom top",
                    id: "s71111",
                    markers: markers,
                    anticipatePin: 1,
                    scrub: 1,
                    invalidateOnRefresh: !0
                }), r(r.CN(".section-7 .bottom-part .card")).css({
                    marginTop: "".concat(-.5 * (window.innerHeight - r(r.CN(".section-7 .top-part .pic")).outerHeight()), "px")
                })
            }))
        },
        "./src/sections/section8/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/sections/section9/index.js": function(t, e, n) {
            "use strict";
            n("jquery")((function() {}))
        },
        "./src/widgets/FullScreenVideo/index.js": function(t, e, n) {
            "use strict";
            n.r(e);
            var r = n("jquery");
            r((function() {
                function t() {
                    try {
                        r(r.CN(".full_screen_video iframe")).get(0).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
                    } catch(t) {}
                    window.afterPopupHidden()
                }(function() {
                    var t = document.querySelectorAll(r.CN(".as-youtube-video"));
                    if(t.length > 0) {
                        r(t[0]).attr("src", r(t[0]).data("src"));
                        var e = document.createElement("script");
                        e.src = "https://www.youtube.com/iframe_api";
                        var n = document.getElementsByTagName("script")[0];
                        n.parentNode.insertBefore(e, n);
                        var o = [],
                            i = function(t) {
                                document.addEventListener("hide.all.modals", (function(t) {
                                    for(var e = 0; e < o.length; e++) o[e].pauseVideo()
                                }))
                            };
                        window.onYouTubeIframeAPIReady = function() {
                            for(var e = 0; e < t.length; e++) o.push(new window.YT.Player(t[e], {
                                events: {
                                    onReady: i
                                }
                            }))
                        }
                    }
                })(), r(r.CN("#playVideo")).on("click", (function(t) {
                    window.afterPopupShown(), e.play()
                })), r(r.CN(".full_screen_video")).on("click", (function(e) {
                    t()
                })), r(r.CN(".full_screen_video .video-close")).on("click", (function(n) {
                    t(), e.reverse(), n.originalEvent.stopImmediatePropagation()
                }));
                var e = gsap.timeline({
                    paused: !0,
                    onStart: function() {
                        r(r.CN(".full_screen_video")).show(), r(r.CN(".full_screen_video .video")).show(), r(r.CN(".full_screen_video")).addClass("".concat("Dart_H5_", "show"))
                    },
                    onReverseComplete: function() {
                        r(r.CN(".full_screen_video .video")).hide(), r(r.CN(".full_screen_video")).hide(), r(r.CN(".full_screen_video")).removeClass("".concat("Dart_H5_", "show"));
                        var t = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(t)
                    }
                }).add(gsap.fromTo(r.CN(".full_screen_video"), .3, {
                    scale: .95,
                    y: "-2%"
                }, {
                    scale: 1,
                    y: "0%"
                })).add(gsap.fromTo(r.CN(".full_screen_video"), .3, {
                    opacity: 0
                }, {
                    opacity: 1
                }), 0)
            }))
        },
        "./src/i18n/font.less": function(t, e, n) {
            "use strict";
            n.r(e)
        },
        "./node_modules/regenerator-runtime/runtime.js": function(t) {
            var e = function(t) {
                "use strict";
                var e, n = Object.prototype,
                    r = n.hasOwnProperty,
                    o = Object.defineProperty || function(t, e, n) {
                        t[e] = n.value
                    },
                    i = "function" == typeof Symbol ? Symbol : {},
                    s = i.iterator || "@@iterator",
                    a = i.asyncIterator || "@@asyncIterator",
                    c = i.toStringTag || "@@toStringTag";

                function u(t, e, n) {
                    return Object.defineProperty(t, e, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }), t[e]
                }
                try {
                    u({}, "")
                } catch(t) {
                    u = function(t, e, n) {
                        return t[e] = n
                    }
                }

                function d(t, e, n, r) {
                    var i = e && e.prototype instanceof y ? e : y,
                        s = Object.create(i.prototype),
                        a = new E(r || []);
                    return o(s, "_invoke", {
                        value: T(t, n, a)
                    }), s
                }

                function l(t, e, n) {
                    try {
                        return {
                            type: "normal",
                            arg: t.call(e, n)
                        }
                    } catch(t) {
                        return {
                            type: "throw",
                            arg: t
                        }
                    }
                }
                t.wrap = d;
                var p = "suspendedStart",
                    f = "suspendedYield",
                    g = "executing",
                    h = "completed",
                    m = {};

                function y() {}

                function v() {}

                function w() {}
                var b = {};
                u(b, s, (function() {
                    return this
                }));
                var j = Object.getPrototypeOf,
                    x = j && j(j(S([])));
                x && x !== n && r.call(x, s) && (b = x);
                var C = w.prototype = y.prototype = Object.create(b);

                function N(t) {
                    ["next", "throw", "return"].forEach((function(e) {
                        u(t, e, (function(t) {
                            return this._invoke(e, t)
                        }))
                    }))
                }

                function _(t, e) {
                    function n(o, i, s, a) {
                        var c = l(t[o], t, i);
                        if("throw" !== c.type) {
                            var u = c.arg,
                                d = u.value;
                            return d && "object" == typeof d && r.call(d, "__await") ? e.resolve(d.__await).then((function(t) {
                                n("next", t, s, a)
                            }), (function(t) {
                                n("throw", t, s, a)
                            })) : e.resolve(d).then((function(t) {
                                u.value = t, s(u)
                            }), (function(t) {
                                return n("throw", t, s, a)
                            }))
                        }
                        a(c.arg)
                    }
                    var i;
                    o(this, "_invoke", {
                        value: function(t, r) {
                            function o() {
                                return new e((function(e, o) {
                                    n(t, r, e, o)
                                }))
                            }
                            return i = i ? i.then(o, o) : o()
                        }
                    })
                }

                function T(t, e, n) {
                    var r = p;
                    return function(o, i) {
                        if(r === g) throw new Error("Generator is already running");
                        if(r === h) {
                            if("throw" === o) throw i;
                            return L()
                        }
                        for(n.method = o, n.arg = i;;) {
                            var s = n.delegate;
                            if(s) {
                                var a = P(s, n);
                                if(a) {
                                    if(a === m) continue;
                                    return a
                                }
                            }
                            if("next" === n.method) n.sent = n._sent = n.arg;
                            else if("throw" === n.method) {
                                if(r === p) throw r = h, n.arg;
                                n.dispatchException(n.arg)
                            } else "return" === n.method && n.abrupt("return", n.arg);
                            r = g;
                            var c = l(t, e, n);
                            if("normal" === c.type) {
                                if(r = n.done ? h : f, c.arg === m) continue;
                                return {
                                    value: c.arg,
                                    done: n.done
                                }
                            }
                            "throw" === c.type && (r = h, n.method = "throw", n.arg = c.arg)
                        }
                    }
                }

                function P(t, n) {
                    var r = n.method,
                        o = t.iterator[r];
                    if(o === e) return n.delegate = null, "throw" === r && t.iterator.return && (n.method = "return", n.arg = e, P(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), m;
                    var i = l(o, t.iterator, n.arg);
                    if("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, m;
                    var s = i.arg;
                    return s ? s.done ? (n[t.resultName] = s.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, m) : s : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, m)
                }

                function k(t) {
                    var e = {
                        tryLoc: t[0]
                    };
                    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
                }

                function O(t) {
                    var e = t.completion || {};
                    e.type = "normal", delete e.arg, t.completion = e
                }

                function E(t) {
                    this.tryEntries = [{
                        tryLoc: "root"
                    }], t.forEach(k, this), this.reset(!0)
                }

                function S(t) {
                    if(t) {
                        var n = t[s];
                        if(n) return n.call(t);
                        if("function" == typeof t.next) return t;
                        if(!isNaN(t.length)) {
                            var o = -1,
                                i = function n() {
                                    for(; ++o < t.length;)
                                        if(r.call(t, o)) return n.value = t[o], n.done = !1, n;
                                    return n.value = e, n.done = !0, n
                                };
                            return i.next = i
                        }
                    }
                    return {
                        next: L
                    }
                }

                function L() {
                    return {
                        value: e,
                        done: !0
                    }
                }
                return v.prototype = w, o(C, "constructor", {
                    value: w,
                    configurable: !0
                }), o(w, "constructor", {
                    value: v,
                    configurable: !0
                }), v.displayName = u(w, c, "GeneratorFunction"), t.isGeneratorFunction = function(t) {
                    var e = "function" == typeof t && t.constructor;
                    return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name))
                }, t.mark = function(t) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, u(t, c, "GeneratorFunction")), t.prototype = Object.create(C), t
                }, t.awrap = function(t) {
                    return {
                        __await: t
                    }
                }, N(_.prototype), u(_.prototype, a, (function() {
                    return this
                })), t.AsyncIterator = _, t.async = function(e, n, r, o, i) {
                    void 0 === i && (i = Promise);
                    var s = new _(d(e, n, r, o), i);
                    return t.isGeneratorFunction(n) ? s : s.next().then((function(t) {
                        return t.done ? t.value : s.next()
                    }))
                }, N(C), u(C, c, "Generator"), u(C, s, (function() {
                    return this
                })), u(C, "toString", (function() {
                    return "[object Generator]"
                })), t.keys = function(t) {
                    var e = Object(t),
                        n = [];
                    for(var r in e) n.push(r);
                    return n.reverse(),
                        function t() {
                            for(; n.length;) {
                                var r = n.pop();
                                if(r in e) return t.value = r, t.done = !1, t
                            }
                            return t.done = !0, t
                        }
                }, t.values = S, E.prototype = {
                    constructor: E,
                    reset: function(t) {
                        if(this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !t)
                            for(var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e)
                    },
                    stop: function() {
                        this.done = !0;
                        var t = this.tryEntries[0].completion;
                        if("throw" === t.type) throw t.arg;
                        return this.rval
                    },
                    dispatchException: function(t) {
                        if(this.done) throw t;
                        var n = this;

                        function o(r, o) {
                            return a.type = "throw", a.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o
                        }
                        for(var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var s = this.tryEntries[i],
                                a = s.completion;
                            if("root" === s.tryLoc) return o("end");
                            if(s.tryLoc <= this.prev) {
                                var c = r.call(s, "catchLoc"),
                                    u = r.call(s, "finallyLoc");
                                if(c && u) {
                                    if(this.prev < s.catchLoc) return o(s.catchLoc, !0);
                                    if(this.prev < s.finallyLoc) return o(s.finallyLoc)
                                } else if(c) {
                                    if(this.prev < s.catchLoc) return o(s.catchLoc, !0)
                                } else {
                                    if(!u) throw new Error("try statement without catch or finally");
                                    if(this.prev < s.finallyLoc) return o(s.finallyLoc)
                                }
                            }
                        }
                    },
                    abrupt: function(t, e) {
                        for(var n = this.tryEntries.length - 1; n >= 0; --n) {
                            var o = this.tryEntries[n];
                            if(o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                var i = o;
                                break
                            }
                        }
                        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                        var s = i ? i.completion : {};
                        return s.type = t, s.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(s)
                    },
                    complete: function(t, e) {
                        if("throw" === t.type) throw t.arg;
                        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), m
                    },
                    finish: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e) {
                            var n = this.tryEntries[e];
                            if(n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), O(n), m
                        }
                    },
                    catch: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e) {
                            var n = this.tryEntries[e];
                            if(n.tryLoc === t) {
                                var r = n.completion;
                                if("throw" === r.type) {
                                    var o = r.arg;
                                    O(n)
                                }
                                return o
                            }
                        }
                        throw new Error("illegal catch attempt")
                    },
                    delegateYield: function(t, n, r) {
                        return this.delegate = {
                            iterator: S(t),
                            resultName: n,
                            nextLoc: r
                        }, "next" === this.method && (this.arg = e), m
                    }
                }, t
            }(t.exports);
            try {
                regeneratorRuntime = e
            } catch(t) {
                "object" == typeof globalThis ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e)
            }
        },
        jquery: function(t) {
            "use strict";
            t.exports = $
        }
    },
    e = {};

function n(r) {
    var o = e[r];
    if(void 0 !== o) return o.exports;
    var i = e[r] = {
        exports: {}
    };
    return t[r](i, i.exports, n), i.exports
}
n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return n.d(e, {
            a: e
        }), e
    }, n.d = function(t, e) {
        for(var r in e) n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: e[r]
        })
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, n.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    },
    function() {
        "use strict";
        n("./src/assets/js/common.js"), n("./src/sections/index.js"), n("./src/i18n/index.js")
    }()
}();